import React, { useCallback, useEffect, useMemo, useState } from "react"
import { calculateTotal, calculateTotalWeight, exportToExcel, exportToPDF, filterKeys, funCheckNumber } from "../../Utility/utility.js"
import { isMobile } from "react-device-detect"
import {
  ErrorCard,
  LoadingCard,
  MainContainer,
  NextUITable,
  NoDataCard,
} from "../../components"
import { apiRoute, ENUM_CURRENCY_SETTING_VAL, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, ENUM_TRADEOF_CODE, ENUM_TRADEOF_LIST, ENUM_TRADEOF_TYPE, getModMandatory, getModValue, getModVisiblity, linksUrl, URIEncrypt } from "../../constants/enum.js"
import { useDispatch, useSelector } from "react-redux"
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks.jsx"
import {
  COLUMN_ALIGN_TYPE,
  COLUMN_TYPE,
  FOOTER_TYPE,
} from "../../components/NextUITable.jsx"
import { faEllipsisVertical, faFileInvoice, faFilter, faFilterCircleXmark, faMagnifyingGlass, } from "@fortawesome/free-solid-svg-icons"
import { Button, RadioGroup, Radio, Select, SelectItem, Input, } from "@heroui/react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useNavigate, useNavigation, useParams } from "react-router-dom"
import { DataGrid, getGridNumericOperators, GridPagination, useGridApiContext } from "@mui/x-data-grid"
import { Box, FormControl, Chip, Checkbox, Autocomplete, ListItemText, MenuItem, OutlinedInput, TextField, Typography } from "@mui/material"
import { toast } from "react-toastify"
import { setMixMemoData, setNewEntryMode, setStockMemoData } from "../../state/memoEntrySlice.jsx"
import MixStockDetail from "./MixStockDetails.jsx"
import { setMixStockRptDetail } from "../../state/stockEntrySlice.jsx"
const isNumericColumn = (values) => {
  return values.every(v => !isNaN(parseFloat(v)) && isFinite(v));
};

const SortIconNone = () => <span className="text-blue-300" style={{ fontSize: "12px" }}>⇅</span>;
const SortIconAsc = () => <span className="text-blue-400" style={{ fontSize: "12px" }}>▲</span>;
const SortIconDesc = () => <span className="text-blue-400" style={{ fontSize: "12px" }}>▼</span>;
const MixStock = () => {
  const { compCode, compName } = useSelector((state) => state.company)
  const { mixStockRptDetail } = useSelector((state) => state.stockEntry);
  const [selectedItem, setSelectedItem] = useState("")
  const [selTradeOf, setSelTradeOf] = useState(Object.keys(mixStockRptDetail)?.length > 0 ? mixStockRptDetail?.tradeof || "" : "")
  const [selModName, setSelModName] = useState("")
  const [CurrencySetting, setCurrencySetting] = useState("")
  const [modSettingParams, setModSettingParams] = useState("")
  const [detailParams, setDetailParams] = useState("")
  const [mixStockParams, setMixStockParams] = useState("")
  const [stockType, setStockType] = useState("OnHand")
  const [selectFilter, setSelectFilter] = useState({});
  const [selectedRows, setSelectedRows] = useState([])
  const [sortConfig, setSortConfig] = useState({ field: null, order: null });
  const dispatch = useDispatch();
  const navi = useNavigate();

  const { stype } = useParams()
  const SelectorIcon = (props) => {
    return (
      <svg
        aria-hidden="true"
        fill="currentColor"
        focusable="false"
        role="presentation"
        viewBox="0 0 24 24"
        width="0.5rem"
        height="0.5rem"
        {...props}
      >
        <path d="M3 4h18c.6 0 1 .5.8 1.1L15 12.5V20c0 .3-.2.6-.5.8l-4 2c-.5.2-1-.2-1-.8v-9.5L2.2 5.1C2 4.5 2.4 4 3 4z" />
      </svg>


    );
  };

  const { data: itemMasterData = [] } = useFetchWithBody({
    url: apiRoute.stockEntry.fetchMasterData,
    queryKey: "StockItemMaster",
  })

  const funFilterData = (action, tradeof, stockparam) => {
    // const order_param = mixStockParams
    //   .map(item => ParamOrd[item.split(",")[0]])
    //   .filter(Boolean).join(",");
    // console.log(order_param, "sffre")
    const d = ` Party, ${stockparam.join(",")}`;
    filterStock({
      data: {
        action: action,
        comp_code: compCode.join(","),
        trade_of: tradeof,
        stock_param: action == 'Memo' ? d : stockparam.join(",")
        //order_param:` , ${order_param}`
      }
    })
  }
  // useEffect(() => {
  //   if (Object.keys(mixStockRptDetail)?.length > 0 && mixStockParams != "") {
  //     if (mixStockRptDetail?.tradeof == selTradeOf ) {
  //       filterStock({
  //         data: {
  //           action: "onHand",
  //           comp_code: compCode.join(","),
  //           trade_of: mixStockRptDetail?.tradeof,
  //           stock_param: mixStockParams.join(","),
  //         }
  //       })
  //     }
  //   }
  // }, [mixStockParams, mixStockRptDetail])
  const RowsField = {
    id: "id",
    detail: "detail",
    LotNo: "L_Code",
    LwRatio: "Lw_Code",
    Shape: "Shape_Name",
    Item: "Item_Name",
    Color: "Color_Name",
    Purity: "Purity_Name",
    Size: "Size_Name",
    Pcs: "Pcs",
    Weight: "Cost_Weight",
    MemoPcs: "MemoPcs",
    MemoWeight: "MemoWeight",
    OnHandPcs: "OnHandPcs",
    OnHandWeight: "OnHandWeight",
    Amount: "Cost_AmtRs",
    AmountD: "Cost_AmtD",
    Party: "Party",
    Rate: "Cost_Rate",
    RateD: "Cost_RateD"
  }
  const handleResetFilter = () => {
    setSelectedItem("")
    funFilterData(stockType, null, mixStockParams)
    dispatch(setMixStockRptDetail({}))
  }
  const { isError: isErrorModSet, data: modSetting = [], mutate: filterModSetting } = usePost({
    url: apiRoute.modSetting.getMultiModSetting,
    queryKey: "fetchModSettingStockItem",
  })
  // useEffect(() => {
  //   if (selModName != "") {
  //     filterModSetting({
  //       data: {
  //         page_mod: selModName,
  //         master_mod: ENUM_MOD_NAME.GeneralSettings
  //       }
  //     })
  //   }
  // }, [selModName])


  const {
    data = [],
    isError,
    isPending,
    mutate: filterStock,
  } = usePost({
    url: apiRoute.stockEntry.fetchMixStock,
    queryKey: "GetStock",
    onSuccessTasks: (data) => {
      if (data && data.length > 0) {
        if (stockType == 'Mix')
          setRows(data.filter(ele => ele.OnHandWeight > 0))
        else
          setRows(data.filter(ele => ele.Weight > 0))
      }
      else
        setRows(data)
    }

  })

  const [rows, setRows] = useState([])
  const getModSettingName = (tradeType) => {
    let modName = ''
    if (tradeType == ENUM_TRADEOF_CODE.Polish) {
      modName = ENUM_MOD_NAME.StockPolishMix
    }
    else if (tradeType == ENUM_TRADEOF_CODE.Rough) {
      modName = ENUM_MOD_NAME.StockRoughMix
    }
    else if (tradeType == ENUM_TRADEOF_CODE.Rejection) {
      modName = ENUM_MOD_NAME.StockRejectionMix
    }

    return modName
  }
  useEffect(() => {
    if (stype && stype != "") {
      if (['mix'].includes(stype)) {
        filterModSetting({
          data: {
            page_mod: selModName,
            master_mod: ENUM_MOD_NAME.GeneralSettings
          }
        })
      }
    }
  }, [stype])
  const finalRows = useMemo(() => {
    let filtered = rows.filter(item => {
      return Object.keys(selectFilter).every(field => {
        const selected = selectFilter[field];
        if (!selected?.length) return true;
        return selected.includes([RowsField.Pcs, RowsField.Weight, RowsField.MemoPcs, RowsField.MemoWeight
          , RowsField.OnHandPcs, RowsField.OnHandWeight, RowsField.Amount, RowsField.AmountD].includes(field) ? item[field] : String(item[field]));
      })

    });


    if (sortConfig.field && sortConfig.order) {
      const field = sortConfig.field;
      const values = filtered.map(r => r[field]);
      const isNum = isNumericColumn(values);

      filtered = [...filtered].sort((a, b) => {
        const av = a[field];
        const bv = b[field];
        if (isNum) return sortConfig.order === "asc" ? av - bv : bv - av;
        return sortConfig.order === "asc"
          ? String(av).localeCompare(String(bv))
          : String(bv).localeCompare(String(av));
      });
    }

    return filtered;
  }, [rows, selectFilter, sortConfig]);
  let totalPcs = useMemo(
    () =>
      calculateTotal({
        data: finalRows,
        columnName: "Pcs",
      }),
    [finalRows]
  )


  let totalWeight = useMemo(
    () =>
      calculateTotalWeight({
        data: finalRows,
        columnName: "Cost_Weight",
      }),
    [finalRows]
  )
  const totalMemoPcs = useMemo(
    () =>
      calculateTotal({
        data: finalRows,
        columnName: "MemoPcs",
      }),
    [finalRows]
  )
  const totalMemoWeight = useMemo(
    () =>
      calculateTotalWeight({
        data: finalRows,
        columnName: "MemoWeight",
      }),
    [finalRows]
  )
  const totalOnHandWeight = useMemo(
    () =>
      calculateTotalWeight({
        data: finalRows,
        columnName: "OnHandWeight",
      }),
    [finalRows]
  )
  const totalOnHandPcs = useMemo(
    () =>
      calculateTotal({
        data: finalRows,
        columnName: "OnHandPcs",
      }),
    [finalRows]
  )

  let totalAmount = useMemo(
    () =>
      calculateTotal({
        data: finalRows,
        columnName: "Cost_AmtRs",
      }),
    [finalRows]
  )
  let totalAmountD = useMemo(
    () =>
      calculateTotal({
        data: finalRows,
        columnName: "Cost_AmtD",
      }),
    [finalRows]
  )

  let avgRate = useMemo(() => {
    const d = parseFloat(totalAmountD) / parseFloat(totalWeight)
    return funCheckNumber(d).toFixed(2)
  }, [totalAmountD, totalWeight])


  let avgRateRs = useMemo(() => {
    const d = parseFloat(totalAmount) / parseFloat(totalWeight)
    return funCheckNumber(d).toFixed(2)
  }, [totalAmount, totalWeight,])

  const INITIAL_VISIBLE_COLUMNS = [
    "Item_Name",
    "L_Code",
    "Shape_Name",
    "Purity_Name",
    "Color_Name",
    "Size_Name",
    "Lw_Code",
    "Party",
    "Pcs",
    "Weight",
    "OnHandPcs",
    "OnHandWeight",
    "MemoPcs",
    "MemoWeight",
    "SalePcs",
    "SaleWeight",
    "Cost_AmtD",
    "Cost_AmtRs",
  ]
  const [initialColumn, setInitialColumn] = useState(INITIAL_VISIBLE_COLUMNS)
  let downloadDataFooter = {
    Item_Name: "",
    L_Code: "",
    Shape_Name: "",
    Purity_Name: "",
    Color_Name: "",
    Size_Name: "",
    Lw_Code: "",
    Pcs: "Total: " + totalPcs,
    Weight: "Total: " + totalWeight,
    MemoPcs: "Total: " + totalMemoPcs,
    MemoWeight: "Total: " + totalMemoWeight,
    OnHandPcs: "Total: " + totalOnHandPcs,
    OnHandWeight: "Total: " + totalOnHandWeight,
    Cost_AmtD: "Total: " + totalWeight,
    Cost_AmtRs: "Total: " + totalAmount,
  }
  const [dataFooter, setDataFooter] = useState(downloadDataFooter)
  useEffect(() => {
    if (finalRows && finalRows.length > 0 && initialColumn && initialColumn.length > 0) {
      const footerData = filterKeys(downloadDataFooter, initialColumn)
      setDataFooter(footerData)
    }

  }, [finalRows, initialColumn])



  const exportColumns = [

    {
      uid: "Party",
      name: "Party",
    },

    {
      uid: "Item_Name",
      name: "Item Name",
    },
    {
      uid: "L_Code",
      name: "Lot No.",
    },
    {
      uid: "Shape_Name",
      name: "Shape",
    },
    {
      uid: "Lw_Code",
      name: "lw Ratio.",
    },
    {
      uid: "Purity_Name",
      name: "Purity",
    },
    {
      uid: "Color_Name",
      name: "Color",
    },
    {
      uid: "Size_Name",
      name: "Size",
    },
    {
      uid: "Lw_Code",
      name: "lw Ratio.",
    },
    {
      uid: "Pcs",
      name: "Pcs",
    },
    {
      uid: "Weight",
      name: "Weight",
      type: COLUMN_TYPE.weight
    },

    {
      uid: "MemoPcs",
      name: "Memo Pcs",
    },
    {
      uid: "MemoWeight",
      name: "Memo Weight",
      type: COLUMN_TYPE.weight
    },
    {
      uid: "OnHandPcs",
      name: "On Hand Pcs",
      type: COLUMN_TYPE.pcs
    },
    {
      uid: "OnHandWeight",
      name: "On Hand Weight",
      type: COLUMN_TYPE.weight
    },

    {
      uid: "Cost_AmtD",
      name: "Amount($)",
      type: COLUMN_TYPE.number
    },
    {
      uid: "Cost_AmtRs",
      name: "Amount",
      type: COLUMN_TYPE.number
    },
  ]


  const ParamOrd = {
    sz_code: "sz_ord",
    s_code: "s_ord",
    q_code: "q_ord",
    sh_code: "sh_ord",
    item_code: "item_ord"
  }
  console.log(mixStockParams)
  const [exportData, setExportData] = useState(exportColumns)
  useEffect(() => {
    if (modSetting && Object.keys(modSetting).length > 0) {
      const modData = modSetting.pageData
      const generalData = modSetting.masterData
      console.log(modSetting)
      let currency_setting = getModValue(ENUM_MOD_PARAMETER.GeneralSetting.CurrencyType, generalData) ?? ENUM_CURRENCY_SETTING_VAL.RS
      setCurrencySetting(currency_setting)
      let visibleCol = []
      let currencyColumn = ["Cost_AmtRs"]
      if (currency_setting == ENUM_CURRENCY_SETTING_VAL.Dollar)
        currencyColumn = ["Cost_AmtD"]
      else if (currency_setting == ENUM_CURRENCY_SETTING_VAL.DUAL)
        currencyColumn = ["Cost_AmtD", "Cost_AmtRs"]

      //setModSettingParams([...visibleCol, "BPcs", "BWeight", ...currencyColumn])

      let mStockParam = []
      // let detStockParam = []

      if (selTradeOf == "R") {
        if (getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.RoughStockByLCode, generalData)) {
          mStockParam = [...mStockParam, 'L_Code']
          visibleCol = [...visibleCol, "L_Code"]
        }
        if (getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.RoughStockByLCode, generalData)) {
          mStockParam = [...mStockParam, 'item_Code ,Item_Name']
          visibleCol = [...visibleCol, "Item_Name"]
        }
        if (getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.RoughStockByLCode, generalData)) {
          mStockParam = [...mStockParam, 'sz_code,Size_Name']
          visibleCol = [...visibleCol, "Size_Name"]
        }
      }
      else {
        if (getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.MixStockByItem, generalData)) {
          mStockParam = [...mStockParam, 'item_code ,Item_Name']
          visibleCol = [...visibleCol, "Item_Name"]
        }
        if (getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.MixStockByLCode, generalData)) {
          mStockParam = [...mStockParam, 'L_Code']
          visibleCol = [...visibleCol, "L_Code"]
        }
        if (getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.MixStockByShape, generalData)) {
          mStockParam = [...mStockParam, 's_code,Shape_Name']
          visibleCol = [...visibleCol, "Shape_Name"]
        }
        if (getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.MixStockByColor, generalData)) {
          mStockParam = [...mStockParam, 'sha_code,Color_Name']
          visibleCol = [...visibleCol, "Color_Name"]
        }
        if (getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.MixStockByPurity, generalData)) {
          mStockParam = [...mStockParam, 'q_code,Purity_Name']
          visibleCol = [...visibleCol, "Purity_Name"]
        }
        if (getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.MixStockBySize, generalData)) {
          mStockParam = [...mStockParam, 'sz_code,Size_Name']
          visibleCol = [...visibleCol, "Size_Name"]
        }
        if (getModMandatory(ENUM_MOD_PARAMETER.GeneralSetting.MixStockByLwRatio, generalData)) {
          mStockParam = [...mStockParam, 'lw_code']
          visibleCol = [...visibleCol, "Lw_Code"]
        }
      }


      setMixStockParams(mStockParam)
      const show_Column = stockType == 'Memo' ?
        ['Party', ...visibleCol, 'Pcs', 'Weight'] :
        // ['Party', 'Pcs', 'Weight'] :
        stockType == "Mix" ? [...visibleCol, 'Pcs', 'Weight', 'MemoPcs', 'MemoWeight', 'OnHandPcs', 'OnHandWeight']
          : [...visibleCol, 'Pcs', 'Weight', ...currencyColumn]
      setInitialColumn(show_Column)


      setExportData(exportColumns.filter(ele => show_Column.includes(ele.uid)))

    }

  }, [modSetting, selTradeOf, stockType])

  const [filterModel, setFilterModel] = useState({
    items: [],
  });
  //console.log(mixStockParams)

  const handleFilter = () => {
    if (selTradeOf && selTradeOf != "" && selTradeOf != null) {
      funFilterData(stockType, selTradeOf, mixStockParams)
      setFilterModel({ items: [], })


    }
    else {
      toast.error("Select Stock Of", {
        "position": "top-center"
      })
    }
  }

  const handleRadioChange = (value) => {
    setStockType(value)
    setSelectFilter({})
    setGridColumnFilter({})
    if (selTradeOf && selTradeOf != "" && selTradeOf != null) {
      funFilterData(value, selTradeOf, mixStockParams)
      setFilterModel({ items: [], })
    }
  }

  const handleDetail = (row) => {
    const result = mixStockParams.flatMap(item => item.split(','));
    const obj = { data: row, params: result, tradeof: selTradeOf }

    dispatch(setMixStockRptDetail(obj))
    navi(linksUrl.stockEntry.rptMixStockDetail)

  }

  const itemGridHeadClass = "report-grid-style"
  const numericOperators = getGridNumericOperators();

  const setColumnVisiblity = (column) => {
    if (initialColumn.includes(column))
      return true
    else return false
  }
  const [gridColumnFilter, setGridColumnFilter] = useState({});

  const getUniqueValues = (field) => {
    const values = new Set(data.map((row) => row[field])
      .filter(value => value !== undefined && value !== null && value !== '')
    );
    // const f=values.
    return [...values];
  };


  const filteredUniqueValuesMap = useMemo(() => {
    const map = {};
    initialColumn?.forEach(col => {
      const field = col;
      const values = [...new Set(rows.map(d => d[field]))];
      map[field] = values;
    });
    return map;
  }, [rows, initialColumn]);
  const handleRemoveTag = (field, value) => {
    const updated = selectFilter[field].filter((v) => v !== value);

    handleSelectChange(field, updated);
    // ⬆️ same function Autocomplete uses to update states
  };
  const handleSelectChange = (field, values) => {
    setSelectFilter(prev => ({ ...prev, [field]: values }));
  };
  /* ---------- 3-STATE SORTING ---------- */
  const handleSort = (field) => {
    return () => {
      setSortConfig(prev => {
        if (prev.field !== field) return { field, order: "asc" };
        if (prev.order === "asc") return { field, order: "desc" };
        if (prev.order === "desc") return { field: null, order: null };
      });
    };
  };
  const renderHeadFilter = (name, headername) => {
    const field = name

    const sortIcon =
      sortConfig.field !== field ? <SortIconNone /> :
        sortConfig.order === "asc" ? <SortIconAsc /> :
          sortConfig.order === "desc" ? <SortIconDesc /> :
            <SortIconNone />;
    return (
      <Box sx={{ display: "flex", flexDirection: "column", padding: "2px" }}>

        {/* Title + Sort Button */}
        <Box className={` flex items-center justify-between `}
          // sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
          onClick={handleSort(field)}
          style={{ cursor: "pointer" }}
        >
          <div style={{ fontSize: "0.655rem" }} className=" w-full text-center flex   justify-center items-center leading-snug whitespace-normal h-7 overflow-hidden" >
            {headername}
          </div>
          {sortIcon}
        </Box>

        <Autocomplete
          multiple
          size="small"
          options={(filteredUniqueValuesMap[field] || []).filter(opt => opt != null)} // always fallback to empty array
          value={selectFilter[field] || []}
          onChange={(e, newValue) => handleSelectChange(field, newValue)}
          disabled={!filteredUniqueValuesMap[field] || filteredUniqueValuesMap[field].length === 0}
          noOptionsText="No options available"

          renderTags={() => null}
          slotProps={{
            chip: {
              size: "small",
              sx: { height: 20, fontSize: "10px", padding: "0 4px", "& .MuiChip-label": { padding: 0 } }
            },
            input: { sx: { padding: "2px 0px !important", fontSize: "11px", } },
            popper: { sx: { fontSize: "12px" } },
            listbox: {
              sx: {
                fontSize: "0.6rem",
                "& .MuiAutocomplete-option": { padding: "2px 8px", minHeight: "28px" }
              }
            }
          }}
          sx={{
            "& .MuiAutocomplete-inputRoot": { padding: "0px 4px !important", minHeight: "30px", background: "#FFFFFF" },
            "& .MuiOutlinedInput-root": { padding: "0px !important", height: "30px" }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Search & Select"
              variant="outlined"
              size="small"
              inputProps={{
                ...params.inputProps, // ⚡ make sure inputProps exist
                autoComplete: "off"
              }}
              className="w-full"
              sx={{
                width: "100px",
                "& .MuiInputLabel-root": { fontSize: "11px", }
              }}
            />
          )}
        />




      </Box>
    )
    // return (<Select
    //   name={name}
    //   selectionMode="multiple"
    //   onChange={(e) => handleColumnFilterChange(e)}
    //   variant="bordered"
    //   isVirtualized={true}
    //   showScrollIndicators={true}
    //   itemHeight={23}
    //   selectorIcon={<SelectorIcon />}
    //   value={gridColumnFilter[name]}
    //   classNames={{
    //     selectorIcon: "text-gray-700 text-xs",
    //     innerWrapper: "text-gray-50 ,border-1,p-5"
    //   }}
    //   disableSelectorIconRotation={true}
    //   size="sm"
    //   className={`${name == RowsField.Party ? "w-36" : "w-32"} bg-white text-xs`}
    // >
    //   {getUniqueValues(name).sort((a, b) => a > b ? 1 : -1).map((value) => (
    //     <SelectItem key={value}>
    //       <div style={{ fontSize: "0.7rem", whiteSpace: "nowrap", }}>  {value}</div>
    //     </SelectItem>
    //   ))}
    // </Select>)
  }
  const columns = [
    {
      field: RowsField.detail,
      headerName: "Detail",
      minWidth: 100,
      headerAlign: "center",
      flex: 1,
      align: 'center',
      headerClassName: itemGridHeadClass,
      // renderHeader: () => (
      //   <div>
      //     <Chip size="sm" >detail</Chip>

      //   </div>
      // ),
      renderCell: ({ row }) => (
        <button
          onClick={() => handleDetail(row)}
          className="bg-green-600 text-white whitespace-nowrap h-5 px-3 py-1 rounded text-xs"
        >
          Detail
        </button>
      )
    },
    {
      field: RowsField.Party,
      headerName: "Party",
      minWidth: 100,
      headerAlign: "center",
      flex: 1,
      align: 'center',
      headerClassName: itemGridHeadClass,
      renderHeader: () => (
        <div>
          {/* <div className="text-center">Party</div> */}
          {renderHeadFilter(RowsField.Party, "Party")}

        </div>
      ),
    },
    {
      field: RowsField.Item,
      headerName: "Item",
      minWidth: 100,
      headerAlign: "center",
      flex: 1,
      align: 'center',
      headerClassName: itemGridHeadClass,
      renderHeader: () => (
        <Box>
          {/* <div className="text-center">Item</div> */}
          {renderHeadFilter(RowsField.Item, "Item")}

        </Box>
      ),
    },
    {
      field: RowsField.LotNo,
      headerName: selTradeOf == 'R' ? "Rough No" : "Lot No.",
      minWidth: 70,
      headerAlign: "center",
      flex: 1,
      align: 'center',
      headerClassName: itemGridHeadClass,
      renderHeader: () => (
        <Box>
          {/* <div className="text-center">{selTradeOf == 'R' ? "Rough No" : "Lot No."}</div> */}
          {renderHeadFilter(RowsField.LotNo, selTradeOf == 'R' ? "Rough No" : "Lot No.")}

        </Box>
      ),
    },
    {
      field: RowsField.Shape,
      headerName: "Shape",
      minWidth: 100,
      headerAlign: "center",
      flex: 1,
      align: 'center',
      headerClassName: itemGridHeadClass,
      renderHeader: () => (
        <div className="w-full">
          {/* <div className="text-center">Shape</div> */}
          {renderHeadFilter(RowsField.Shape, "Shape")}

        </div>
      ),
    },
    {
      field: RowsField.Color,
      headerName: "Color",
      minWidth: 100,
      headerAlign: "center",
      flex: 1,
      align: 'center',
      headerClassName: itemGridHeadClass,
      renderHeader: () => (
        <Box>
          {/* <div className="text-center">Color</div> */}
          {renderHeadFilter(RowsField.Color, "Color")}

        </Box>
      ),

    },
    {
      field: RowsField.Purity,
      headerName: "Purity",
      minWidth: 100,
      headerAlign: "center",
      flex: 1,
      align: 'center',
      headerClassName: itemGridHeadClass,
      renderHeader: () => (
        <Box>
          {/* <div className="text-center">Purity</div> */}
          {renderHeadFilter(RowsField.Purity, "Purity")}

        </Box>
      ),
    },
    {
      field: RowsField.Size,
      headerName: "Size",
      minWidth: 100,
      headerAlign: "center",
      flex: 1,
      align: 'center',
      headerClassName: itemGridHeadClass,
      renderHeader: () => (
        <Box>
          {/* <div className="text-center">Size</div> */}
          {renderHeadFilter(RowsField.Size, "Size")}

        </Box>
      ),
    },
    {
      field: RowsField.LwRatio,
      headerName: "LxW Ratio.",
      minWidth: 70,
      headerAlign: "center",
      flex: 1,
      align: 'center',
      headerClassName: itemGridHeadClass,
      renderHeader: () => (
        <Box>
          {/* <div className="text-center">LxW Ratio</div> */}
          {renderHeadFilter(RowsField.LwRatio, "LxW Ratio")}

        </Box>
      ),
    },

    {
      field: RowsField.Pcs,
      headerName: "Pcs",
      minWidth: 70,
      headerAlign: "center",
      flex: 1,
      align: 'center',
      type: 'number',
      align: 'right',
      headerClassName: itemGridHeadClass,
      filterOperators: numericOperators,
      renderHeader: () => (
        <Box>
          {/* <div className="text-center">Pcs</div> */}
          {renderHeadFilter(RowsField.Pcs, "Pcs")}

        </Box>
      ),

    },
    {
      field: RowsField.Weight,
      headerName: "Weight",
      minWidth: 70,
      headerAlign: "center",
      flex: 1,
      type: 'number',
      align: 'right',
      type: 'number',
      headerClassName: itemGridHeadClass,
      valueFormatter: (params) => {
        if (params == null) return 0;
        return parseFloat(params).toFixed(3);
      },
      filterOperators: numericOperators,
      renderHeader: () => (
        <Box>
          {/* <div className="text-center">Weight</div> */}
          {renderHeadFilter(RowsField.Weight, "Weight")}

        </Box>
      ),

    },
    {
      field: RowsField.MemoPcs,
      headerName: "Memo Pcs",
      minWidth: 70,
      headerAlign: "center",
      flex: 1,
      align: 'center',
      type: 'number',
      align: 'right',
      headerClassName: itemGridHeadClass,
      filterOperators: numericOperators,
      renderHeader: () => (
        <Box>
          {/* <div className="text-center">Memo Pcs</div> */}
          {renderHeadFilter(RowsField.MemoPcs, "Memo Pcs")}

        </Box>
      ),

    },
    {
      field: RowsField.MemoWeight,
      headerName: "Memo Weight",
      minWidth: 70,
      headerAlign: "center",
      flex: 1,
      type: 'number',
      align: 'right',
      type: 'number',
      headerClassName: itemGridHeadClass,
      valueFormatter: (params) => {
        if (params == null) return 0;
        return parseFloat(params).toFixed(3);
      },
      filterOperators: numericOperators,
      renderHeader: () => (
        <Box>
          {/* <div className="text-center">Memo Weight</div> */}
          {renderHeadFilter(RowsField.MemoWeight, "Memo Weight")}

        </Box>
      ),

    },
    {
      field: RowsField.OnHandPcs,
      headerName: "On Hand Pcs",
      minWidth: 70,
      headerAlign: "center",
      flex: 1,
      align: 'center',
      type: 'number',
      align: 'right',
      headerClassName: itemGridHeadClass,
      filterOperators: numericOperators,
      renderHeader: () => (
        <Box>
          {/* <div className="text-center">On Hand Pcs</div> */}
          {renderHeadFilter(RowsField.OnHandPcs, "On Hand Pcs")}

        </Box>
      ),

    },
    {
      field: RowsField.OnHandWeight,
      headerName: "On Hand Weight",
      minWidth: 70,
      headerAlign: "center",
      flex: 1,
      type: 'number',
      align: 'right',
      type: 'number',
      headerClassName: itemGridHeadClass,
      valueFormatter: (params) => {
        if (params == null) return 0;
        return parseFloat(params).toFixed(3);
      },
      filterOperators: numericOperators,
      renderHeader: () => (
        <Box>
          {/* <div className="text-center">On Hand Weight</div> */}
          {renderHeadFilter(RowsField.OnHandWeight, "On Hand Weight")}

        </Box>
      ),

    },
    {
      field: RowsField.Rate,
      headerName: "Rate.",
      minWidth: 100,
      headerAlign: "center",
      flex: 1,
      align: 'right',
      type: 'number',
      headerClassName: itemGridHeadClass,
      filterOperators: numericOperators,
      renderHeader: () => (
        <Box>
          {/* <div className="text-center">Amount</div> */}
          {renderHeadFilter(RowsField.Rate, "Rate")}

        </Box>
      ),
    },
    {
      field: RowsField.Amount,
      headerName: "Amt.",
      minWidth: 100,
      headerAlign: "center",
      flex: 1,
      align: 'right',
      type: 'number',
      headerClassName: itemGridHeadClass,
      filterOperators: numericOperators,
      renderHeader: () => (
        <Box>
          {/* <div className="text-center">Amount</div> */}
          {renderHeadFilter(RowsField.Amount, "Amount")}

        </Box>
      ),
    },
    {
      field: RowsField.RateD,
      headerName: "Rate($)",
      minWidth: 100,
      headerAlign: "center",
      flex: 1,
      align: 'right',
      type: 'number',
      headerClassName: itemGridHeadClass,
      filterOperators: numericOperators,
      renderHeader: () => (
        <Box>
          {/* <div className="text-center">Amount</div> */}
          {renderHeadFilter(RowsField.RateD, "Rate($)")}

        </Box>
      ),
    },
    {
      field: RowsField.AmountD,
      headerName: "Amt ($)",
      minWidth: 100,
      headerAlign: "center",
      flex: 1,
      align: 'right',
      type: 'number',
      headerClassName: itemGridHeadClass,
      filterOperators: numericOperators,
      renderHeader: () => (
        <Box>
          {/* <div className="text-center">Amount ($)</div> */}
          {renderHeadFilter(RowsField.AmountD, "Amount ($)")}

        </Box>
      ),
    }
  ]

  const emptyRowField = Object.values(RowsField).reduce((acc, key) => {
    acc[key] = '';
    return acc;
  }, {});



  // const applyFilter = (row, filter) => {

  //   const { field, operator } = filter;
  //   //onst operator = filter.operator;
  //   const filterValue = filter.value;

  //   const cellValue = row[field];

  //   if (filterValue === undefined || filterValue === null) return true;

  //   const filterValStr = filterValue.toString().toLowerCase();
  //   const cellValStr = (cellValue ?? '').toString().toLowerCase();

  //   switch (operator) {
  //     case 'contains':
  //       return cellValStr.includes(filterValStr);
  //     case 'doesNotContain':
  //       return !cellValStr.includes(filterValStr);
  //     case 'doesNotEqual':
  //       return cellValStr !== filterValStr;
  //     case 'isEmpty':
  //       return cellValStr == filterValStr;
  //     case 'isNotEmpty ':
  //       return cellValStr !== '';
  //     case 'equals':
  //       return cellValStr === filterValStr;
  //     case 'startsWith':
  //       return cellValStr.startsWith(filterValStr);
  //     case 'endsWith':
  //       return cellValStr.endsWith(filterValStr);
  //     case 'isAnyOf':
  //       return Array.isArray(filterValue) && filterValue.includes(cellValue);
  //     case '=':
  //       return Number(cellValue) == Number(filterValue);
  //     case '>':
  //       return Number(cellValue) > Number(filterValue);
  //     case '>=':
  //       return Number(cellValue) >= Number(filterValue);
  //     case '<':
  //       return Number(cellValue) < Number(filterValue);
  //     case '<=':
  //       return Number(cellValue) <= Number(filterValue);
  //     default:
  //       return true;
  //   }
  // };

  const getSelStockType = () => {
    if (selTradeOf == ENUM_TRADEOF_CODE.Polish)
      return ENUM_TRADEOF_TYPE.Polish
    else if (selTradeOf == ENUM_TRADEOF_CODE.Rough)
      return ENUM_TRADEOF_TYPE.Rough
    else if (selTradeOf == ENUM_TRADEOF_CODE.Rejection)
      return ENUM_TRADEOF_TYPE.Rejection
  }
  const handleAutoCompleteChange = (val) => {
    setSelTradeOf(val)
    setRows([])
    //setSelModName(getModSettingName(val))
  }

  // const handleFilterChange = (newFilterModel) => {
  //   setFilterModel(newFilterModel);

  //   const filtered = data
  //     .filter((row) => row.id !== 'total')
  //     .filter((row) =>
  //       newFilterModel.items.every((filter) => applyFilter(row, filter))
  //     );

  //   // const totalRow = {
  //   //   ...emptyRowField,
  //   //   id: 'total',
  //   //   Cost_AmtD: filtered.reduce((sum, r) => sum + (r.Cost_AmtD || 0), 0),
  //   //   Cost_AmtRs: filtered.reduce((sum, r) => sum + (r.Cost_AmtRs || 0), 0),
  //   // };

  //   setRows(filtered);
  // }

  // useEffect(() => {
  //   console.log("h")
  //   const rData = rows
  //   const totalRow = {
  //     ...emptyRowField,
  //     id: 'total',
  //     Cost_AmtD: rData.reduce((sum, r) => sum + (r.Cost_AmtD || 0), 0),
  //     Cost_AmtRs: rData.reduce((sum, r) => sum + (r.Cost_AmtRs || 0), 0),
  //   };
  //   setRows([...rows, totalRow])
  // }, [])
  const exportExcel = () => {
    exportToExcel({
      data: finalRows,
      downloadFileName: "mixstock",
      exportColumns: exportData
    })
  }

  const exportPdf = () => {
    exportToPDF(
      {
        data: finalRows,
        downloadFileName: "MixStock_" + getSelStockType() + "_Diamonds",
        exportColumns: exportData,
        exportReportType: "MixStock",
        downloadFileheader: [{ key: "", value: compName.join(",") }],
        downloadDataFooter: dataFooter,
      })
  }
  function CustomFooter() {
    const apiRef = useGridApiContext();
    const visibleRowIds = apiRef.current.getSortedRowIds();

    // ----------------------------
    // 1) Track synced scroll & grid width
    // ----------------------------
    const [scrollLeft, setScrollLeft] = React.useState(0);
    const [containerWidth, setContainerWidth] = React.useState(0);

    // Sync scroll from main grid
    useEffect(() => {
      const scroller = document.querySelector('.MuiDataGrid-virtualScroller');
      if (!scroller) return;

      const handleScroll = () => setScrollLeft(scroller.scrollLeft);
      scroller.addEventListener("scroll", handleScroll);

      return () => scroller.removeEventListener("scroll", handleScroll);
    }, []);

    // Track actual total column width to prevent right side cutoff
    useEffect(() => {
      const colContainer = document.querySelector('.MuiDataGrid-columnsContainer');
      if (!colContainer) return;

      const updateWidth = () => setContainerWidth(colContainer.scrollWidth);

      updateWidth();

      const observer = new ResizeObserver(updateWidth);
      observer.observe(colContainer);

      return () => observer.disconnect();
    }, []);

    // ----------------------------
    // 2) Visible rows & columns
    // ----------------------------
    const visibleRows = useMemo(() => {
      return visibleRowIds.map((id) =>
        apiRef.current.getRowWithUpdatedValues(id)
      );
    }, [apiRef, visibleRowIds]);

    const VisibleCol = useMemo(() => {
      return apiRef.current.getAllColumns().filter((col) =>
        initialColumn.includes(col.field)
      );
    }, [apiRef]);

    // ----------------------------
    // 3) Totals calculation
    // ----------------------------
    const totals = useMemo(() => {
      const result = {};

      VisibleCol.forEach((col) => {
        if (col.type === "number") {
          const sum = visibleRows.reduce(
            (acc, row) => acc + (row[col.field] || 0),
            0
          );

          if ([RowsField.Pcs, RowsField.OnHandPcs, RowsField.MemoPcs].includes(col.field)) {
            result[col.field] = sum.toFixed(0);
          } else if ([RowsField.Weight, RowsField.MemoWeight, RowsField.OnHandWeight].includes(col.field)) {
            result[col.field] = sum.toFixed(3);
          } else {
            result[col.field] = sum.toFixed(2);
          }
        } else {
          result[col.field] = "";
        }
      });

      return result;
    }, [VisibleCol, visibleRows]);

    // ----------------------------
    // Render: Scroll-synced footer
    // ----------------------------
    return (
      <Box>

        {/* TOTAL FOOTER ROW (scroll synced + full width) */}
        <Box
          display="flex"
          width={containerWidth || "100%"}   // EXACT data column width → no clipping
          position="relative"
          left={-scrollLeft}                 // Horizontal sync
          bgcolor="#f1f1f1"
          p={1}
        >
          {VisibleCol.map((col) => (
            <Box
              key={col.field}
              fontWeight="bold"
              minWidth={col.minWidth}
              textAlign="right"
              fontSize="11px"
              textTransform="uppercase"
              flex={col.flex}
            >
              {col.type === "number" && (
                <div>
                  <h6 style={{ margin: 0 }}>{col.headerName}</h6>
                  {totals[col.field]}
                </div>
              )}
            </Box>
          ))}
        </Box>

        <GridPagination />
      </Box>
    );
  }

  // useEffect(() => {
  //   const selItems = finalRows.filter((ele) => selectedRows.includes(ele.id))
  //   setChkselectedRowsData(selItems)
  // }, [selectedRows])
  // const handleClearGridFilters = () => {
  //  // setGridColumnFilter({})
  //   funFilterData(stockType, selTradeOf, mixStockParams)
  // }
  const handleClearGridFilters = () => {
    setSelectFilter({})

    //funFilterData(stockType, selTradeOf, mixStockParams)
  }
  const getColName = (colName) => {
    if (columns && columns.length > 0) {
      const filData = columns.filter((ele) => ele.field == colName)
      if (filData && filData.length > 0) {
        return filData[0].headerName
      }
      else return colName
    }
    else return ""
  }
  const handleRowSelectionChange = (newSelection) => {

    // const selItems = finalRows.filter((ele) => newSelection.includes(ele.id))

    setSelectedRows(newSelection);


  }

  const handleMemo = () => {
    if (selectedRows && selectedRows.length > 0) {
      const selItems = finalRows.filter((ele) => selectedRows.includes(ele.id))
      //  const selItems = finalRows
      // .filter((ele) => selectedRows.includes(ele.id))
      // .map((item) => ({ ...item, PktType: 'MIX' })); // Add PktType: 'Mix'


      dispatch(setNewEntryMode(true))
      dispatch(setMixMemoData(selItems))
      if (selTradeOf == "P")
        navi(linksUrl.saleEntry.polishDiamond + URIEncrypt.Sale + "/" + URIEncrypt.Polish + "/" + URIEncrypt.Mix + linksUrl.mixEntry + linksUrl.memoEntry.createMemoEntry)
      else if (selTradeOf == "R")
        navi(linksUrl.saleEntry.roughDiamond + URIEncrypt.Sale + "/" + URIEncrypt.Rough + "/" + URIEncrypt.Mix + linksUrl.mixEntry + linksUrl.memoEntry.createMemoEntry)

    }
    else {
      toast.error("First Select Items", {
        "position": "top-center"
      })
    }
  }
  if (isPending) {
    return <LoadingCard />
  }

  if (isError) {
    return <ErrorCard />
  }

  return (
    <div>
      <MainContainer pageName="Mix Stock" info={[]} breadcrumbs={["Stock", "Mix Stock"]}>
        <div className={`  w-full  bg-white shadow border-1 p-2 `}>
          <div className="flex w-full flex-col">

            <div className="flex  flex-wrap items-center gap-2  mb-2">
              <div className={`flex  items-center gap-2  ${isMobile ? 'w-full' : 'lg:w-3/5 sm:w-full'}`}>
                <Select
                  size="sm"
                  name={"item"}
                  label={"Stock Of"}
                  color={"danger"}
                  eventResizeFeature={true}
                  selectionMode="single"
                  showScrollIndicators={true}
                  placeholder={"--Select--"}
                  classNames={{
                    label: "text-xs text-black font-bold",
                  }}
                  isClearable={true}
                  variant="flat"
                  isVirtualized
                  items={
                    ENUM_TRADEOF_LIST
                  }
                  onChange={(e) => handleAutoCompleteChange(e.target.value)}
                  selectedKeys={selTradeOf}
                >
                  {(list) => (
                    <SelectItem
                      key={list.key}
                    >
                      {list.value}
                    </SelectItem>
                  )}
                </Select>

              </div>
              <div className={`flex  items-center gap-2 `}>
                <Button
                  color="primary"
                  size="sm"
                  startContent={<FontAwesomeIcon icon={faMagnifyingGlass} />}
                  onPress={handleFilter}
                  className="bg-slate-700"
                // isLoading={isPending}
                >
                  Find
                </Button>
                <Button
                  style={{ marginLeft: "5px" }}
                  size="sm"
                  color="primary"
                  startContent={<FontAwesomeIcon icon={faFilter} />}
                  onPress={handleResetFilter}
                >
                  Reset
                </Button>
              </div>
            </div>

          </div>

          <div className="flex gap-5 justify-between mb-5">
            {selectFilter && Object.keys(selectFilter).length > 0 ? <>
              {/* <Chip onClick={handleClearGridFilters} size="sm" variant="bordered" className="cursor-pointer text-gray-700">
                          <FontAwesomeIcon className="text-orange-600" icon={faFilterCircleXmark}></FontAwesomeIcon> Remove Filters</Chip> */}
              <Chip icon={<FontAwesomeIcon style={{ fontSize: "12px", color: "#ff6a00" }}
                icon={faFilterCircleXmark}></FontAwesomeIcon>} label=" Remove Filters"
                onClick={handleClearGridFilters} size="small"
                variant="outlined"
                className="cursor-pointer text-gray-700"
                sx={{
                  color: "#383737ff",
                  // Text color,
                  // borderColor: "#6e6e6eff",         // Border color
                  "& .MuiChip-label": {
                    fontSize: "11px"
                  },
                  "& .MuiChip-icon": {
                    marginLeft: "4px"
                  },
                }}>
              </Chip>

            </>
              : "-"}

            <div className="flex gap-2">
              {stockType == 'OnHand' ?
                <Button size="sm" className="bg-blue-700" isDisabled={finalRows.length <= 0 ? true : false} color="danger"
                  startContent={<FontAwesomeIcon icon={faFileInvoice} />}
                  onPress={handleMemo}> {isMobile ? "Memo" : "Generate Memo"}</Button> : ""}
              <Button size="sm" isDisabled={rows.length <= 0 ? true : false} color="success" onPress={exportExcel}>Export Excel</Button>
              <Button size="sm" isDisabled={rows.length <= 0 ? true : false} color="danger" onPress={exportPdf}>Export PDF</Button>


            </div>
          </div>
          <div className="ml-3">
            <RadioGroup label="" color={"secondary"} size="sm" className="mb-5 text-center" orientation="horizontal" value={stockType} onValueChange={handleRadioChange}>
              <Radio classNames={{ base: `${stockType == 'Stock' ? 'bg-orange-600' : 'bg-gray-400'} rounded-sm  h-7   mr-3 `, label: "text-white w-22" }} value="Stock">OverAll Stock</Radio>
              <Radio classNames={{ base: `${stockType == 'Memo' ? 'bg-orange-600' : 'bg-gray-400'} rounded-sm  h-7 mr-3 `, label: "text-white w-14" }} value="Memo">Memo</Radio>
              <Radio classNames={{ base: `${stockType == 'OnHand' ? 'bg-orange-600' : 'bg-gray-400'} rounded-sm h-7  mr-3 `, label: "text-white w-14 " }}
                value="OnHand">On Hand</Radio>
              <Radio classNames={{ base: `${stockType == 'Mix' ? 'bg-orange-600' : 'bg-gray-400'} rounded-sm  h-7 mr-3 `, label: "text-white w-22" }} value="Mix"> Combine Stock</Radio>
            </RadioGroup>
          </div>
          {/* {
          gridColumnFilter && Object.keys(gridColumnFilter).length > 0 ?
            <Chip onClick={handleClearGridFilters} size="sm" variant="bordered" className="cursor-pointer text-gray-700">
              <FontAwesomeIcon className="text-orange-600" icon={faFilterCircleXmark}></FontAwesomeIcon> Remove Filters</Chip>
            : ""} */}
          <div className="mb-5" style={{ display: "flex", flexDirection: "row", gap: 4 }}>
            {Object.entries(selectFilter).map(([field, values]) => (
              <div key={field} style={{ display: "flex", alignItems: "center", gap: 6, flexWrap: "wrap" }}>
                <strong style={{ fontSize: "0.6rem" }} className="text-xs uppercase"> {values.length > 0 ? getColName(field) + " :" : ""} </strong>
                {values.map(value => (
                  <Chip
                    key={`${field}-${value}`}
                    label={value}
                    onDelete={() => handleRemoveTag(field, value)}
                    size="small"
                    color="primary"
                    variant="outlined"
                    sx={{ height: 22, fontSize: "11px" }}
                  />
                ))}
              </div>
            ))}
          </div>
          {/* <MixStockDetail/> */}
          {data && data.length > 0 ? <>
            <Box sx={{ height: rows.length > 20 ? 500 : "auto", width: '100%' }}>
              <DataGrid
                rows={finalRows}
                columns={columns}
                columnHeaderHeight={65}
                rowHeight={30}
                disableColumnMenu={true}
                disableColumnSorting={false}
                checkboxSelection={true}
                onRowSelectionModelChange={handleRowSelectionChange}
                rowSelectionModel={selectedRows}
                initialState={data && data.length > 0 ? {
                  pagination: { paginationModel: { pageSize: 50, page: 0 } },
                } : {}}
                // slots={data && data.length > 0 ? {
                //   footer: CustomFooter,
                // } : {}}
                getRowId={(row) => row.id}
                // filterModel={filterModel}
                //onFilterModelChange={handleFilterChange}
                getRowClassName={(params) => {
                  if (params.id == 'total') {
                    return 'sticky-row';  // Add custom class to the last row
                  }
                  return 'row-class';
                }}
                sx={{
                  '& .MuiDataGrid-columnHeaders': {
                    position: 'sticky',
                    top: 0,
                    backgroundColor: '#fff',
                    zIndex: 1,
                  },
                  '& .MuiDataGrid-columnHeaderTitle': {
                    fontWeight: 'bold',
                  },
                  '& .sticky-row': {
                    position: 'sticky',
                    bottom: 0,
                    color: "#FFFFFF",
                    backgroundColor: '#424242f5',
                    zIndex: 10,
                    fontSize: "12px"
                  },
                  '& .row-class:hover': {
                    backgroundColor: '#ffeabc',
                  },
                  '& .row-class': {
                    fontSize: '11px',
                  },
                  '& .MuiDataGrid-columnHeader .MuiDataGrid-sortIcon': {
                    display: 'none',
                  },
                  '& .MuiDataGrid-columnHeader .MuiDataGrid-iconSeparator': {
                    display: 'none',
                  },
                  '& .MuiDataGrid-columnHeader .MuiDataGrid-iconButtonContainer': {
                    display: 'none',
                  },
                  '& .MuiDataGrid-columnHeader, & .MuiDataGrid-cell': {
                    paddingLeft: 0,
                    paddingRight: 0,
                    marginLeft: 0,
                    marginRight: 0,
                  },
                  '& .MuiDataGrid-columnHeaderDraggableContainer': {
                    backgroundColor: "#f1f1f1ff"
                  },
                  '& .MuiDataGrid-footerContainer': {
                    backgroundColor: "#f1f1f1ff"
                  }

                }}
                columnVisibilityModel={{
                  [RowsField.Item]: setColumnVisiblity(RowsField.Item),
                  [RowsField.LotNo]: setColumnVisiblity(RowsField.LotNo),
                  [RowsField.Shape]: setColumnVisiblity(RowsField.Shape),
                  [RowsField.Color]: setColumnVisiblity(RowsField.Color),
                  [RowsField.Purity]: setColumnVisiblity(RowsField.Purity),
                  [RowsField.Size]: setColumnVisiblity(RowsField.Size),
                  [RowsField.LwRatio]: setColumnVisiblity(RowsField.LwRatio),
                  [RowsField.Party]: setColumnVisiblity(RowsField.Party),
                  [RowsField.OnHandPcs]: stockType == "Mix" ? true : false,
                  [RowsField.OnHandWeight]: stockType == "Mix" ? true : false,
                  [RowsField.MemoPcs]: stockType == "Mix" ? true : false,
                  [RowsField.MemoWeight]: stockType == "Mix" ? true : false,
                  [RowsField.Rate]: ["Mix", "Memo"].includes(stockType) ? false : CurrencySetting != ENUM_CURRENCY_SETTING_VAL.Dollar ? true : false,
                  [RowsField.Amount]: ["Mix", "Memo"].includes(stockType) ? false : CurrencySetting != ENUM_CURRENCY_SETTING_VAL.Dollar ? true : false,
                  [RowsField.RateD]: ["Mix", "Memo"].includes(stockType) ? false : CurrencySetting != ENUM_CURRENCY_SETTING_VAL.RS ? true : false,
                  [RowsField.AmountD]: ["Mix", "Memo"].includes(stockType) ? false : CurrencySetting != ENUM_CURRENCY_SETTING_VAL.RS ? true : false,
                }}
              />
            </Box>
            <div className={`flex flex-wrap sm:flex-nowrap md:flex-nowrap shadow gap-4 py-5 px-2 mt-3  mb-10 border-1 bg-white`}>
              <div className="flex gap-4">
                <Input size="sm" readOnly={true} label="PCS" labelPlacement="outside" color="danger"
                  className="w-40 font-semibold" value={totalPcs}

                > </Input>
                <Input size="sm" readOnly={true} label=" Weight" labelPlacement="outside" color="danger"
                  className="w-40 font-semibold" value={totalWeight}

                > </Input>
              </div>
              <div className="flex gap-4">
                <Input size="sm" readOnly={true} label="Total Amt" labelPlacement="outside" color="success"
                  className="w-40 font-semibold"
                  value={totalAmount}

                  startContent={
                    <div className="pointer-events-none flex items-center">
                      <span className="text-default-400 text-small">₹</span>
                    </div>
                  }
                >  </Input>
                <Input size="sm" readOnly={true} label="Avg Rate(₹) " labelPlacement="outside" color="warning"
                  className="w-40 font-semibold"
                  value={avgRateRs}
                  startContent={
                    <div className="pointer-events-none flex items-center">
                      <span className="text-default-400 text-small">₹</span>
                    </div>
                  }
                > </Input>


              </div>
              <div className="flex gap-4">
                <Input size="sm" readOnly={true} label="Total Amt($)" labelPlacement="outside" color="success"
                  className="w-40 font-semibold"
                  value={totalAmountD}
                  startContent={
                    <div className="pointer-events-none flex items-center">
                      <span className="text-default-400 text-small">$</span>
                    </div>
                  }
                > </Input>

                <Input size="sm" readOnly={true} label="Avg Rate($) " labelPlacement="outside" color="warning"
                  className="w-40 font-semibold"
                  value={avgRate}
                  startContent={
                    <div className="pointer-events-none flex items-center">
                      <span className="text-default-400 text-small">$</span>
                    </div>
                  }
                > </Input>
              </div>



            </div>
          </> :
            <NoDataCard />}
        </div>
      </MainContainer>
    </div>
  )
}

export default MixStock

//  if (data && data.length > 0) {
//       const col = Object.keys(data[0]).filter((key) => initialColumn.includes(key)).map((key) => {
//         return {
//           field: key,
//           headerName: key.replace(/_/g, ' '),
//           flex: 1
//           }
//         })
//       return col
//     }
//     return []